/**
 * @generated SignedSource<<cc2616d421e99ce5feaee6d186acd833>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"VideoOverlay_viewer" | "useItemMediaItems_viewer">;
  readonly " $fragmentType": "PdpRespHeroCarousel_viewer";
};
export type PdpRespHeroCarousel_viewer$key = {
  readonly " $data"?: PdpRespHeroCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemMediaItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VideoOverlay_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a31fd2878e9b1ad49e9fc91a0618a89d";

export default node;
